import { useTranslation } from 'language/translator'
import { useSelector } from 'react-redux'

import {
  selectAllDashboardCategories,
  selectAllEntityCategories,
  selectAllMetricCategories
} from 'redux/selectors/Categories'
import { ApplicationState } from 'redux/Stores/types'

/**
 * Hook for all dashboard categories
 */
export const useDashboardCategories = () => {
  const { lang } = useTranslation()

  return useSelector((state: ApplicationState) =>
    selectAllDashboardCategories(state, lang)
  )
}

/**
 * Hook for all entity categories
 */
export const useEntityCategories = () => {
  const { lang } = useTranslation()

  return useSelector((state: ApplicationState) =>
    selectAllEntityCategories(state, lang)
  )
}

/**
 * Hook for all metric categories
 */
export const useMetricCategories = () => {
  const { lang } = useTranslation()

  return useSelector((state: ApplicationState) =>
    selectAllMetricCategories(state, lang)
  )
}
